import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "./Reveal";
import { ProjectLightbox } from "./ProjectLightbox";

const SPAN = ["md:col-span-4 md:row-span-2", "md:col-span-2", "md:col-span-2", "md:col-span-3", "md:col-span-3"];

const ProjectTile = ({ project, index, onOpen }) => (
  <Reveal delay={(index % 3) * 0.08} className={`bg-slate-900 ${SPAN[index % SPAN.length]}`}>
    <button
      data-testid={`project-tile-${project.id}`}
      onClick={onOpen}
      className="group relative block h-full min-h-[260px] w-full overflow-hidden text-left md:min-h-[300px]"
      aria-label={`Ver projeto ${index + 1}`}
    >
      <img
        src={project.image_url}
        alt={`Projeto ${index + 1} — ${project.category}`}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/20 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-100" />
      <span className="absolute left-5 top-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/80">
        {String(index + 1).padStart(2, "0")}
      </span>
      <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-5 sm:p-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/70">
          {[project.location, project.year].filter(Boolean).join(" · ")}
        </p>
        <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-white/30 text-white transition-all duration-300 group-hover:border-[#C05621] group-hover:bg-[#C05621]">
          <ArrowUpRight size={17} strokeWidth={1.8} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </button>
  </Reveal>
);

export const PortfolioGallery = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(-1);

  useEffect(() => {
    api.projects().then(setProjects).catch(() => {}).finally(() => setLoading(false));
  }, []);


  return (
    <section id="projetos" className="mx-auto max-w-7xl scroll-mt-24 px-5 py-24 sm:px-8 sm:py-32">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#C05621]">Portfólio</p>
        <div className="mt-4 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <h2 data-testid="portfolio-title" className="font-display max-w-xl text-3xl font-extrabold uppercase leading-[1.02] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Nossos projetos
          </h2>
          <p className="max-w-sm text-sm text-slate-500">
            Uma amostra de residências e edifícios comerciais projetados pelo escritório.
            Clique para ver em detalhe.
          </p>
        </div>
      </Reveal>

      {loading ? (
        <div className="mt-12 grid grid-cols-1 gap-px bg-slate-900/10 md:grid-cols-6">
          {[...Array(5)].map((_, i) => (
            <div key={i} className={`min-h-[300px] animate-pulse bg-slate-200 ${SPAN[i]}`} />
          ))}
        </div>
      ) : (
        <div className="mt-12 grid grid-cols-1 gap-px bg-slate-900/10 md:grid-cols-6 md:auto-rows-[300px]" data-testid="portfolio-grid">
          {projects.map((p, i) => (
            <ProjectTile key={p.id} project={p} index={i} onOpen={() => setActive(i)} />
          ))}
        </div>
      )}

      <ProjectLightbox projects={projects} index={active} onClose={() => setActive(-1)} onChange={setActive} />
    </section>
  );
};
